import { TransactionDetails } from '../../types/api.types';
import {
  SET_PAYMENT_DETAILS,
  RESTORE_ORIGINAL_AMOUNT,
} from '../paymentActions';

// Extended state to include original amount tracking
interface PaymentState extends TransactionDetails {
  originalAmount?: string;
}

// Define the initial state with the extended PaymentState type
const initialState: PaymentState = {
  status: 0,
  message: '',
  data: {
    onepay_transaction_id: '',
    request_transaction_id: '',
    gateway_token: '',
    request_amount: '',
    currency: '',
    is_live: false,
    transaction_redirect_url: '',
    request_type: '',
    app: {
      app_id: '',
      app_name: '',
      brand_logo: '',
      banner_bg_color: '#051B13',
      banner_font_color: '#FFFFFF',
      action_bt_text: '',
      action_button_bt_color: '#7BC8A1',
      greeting_message: '',
      redirection_url: '',
    },
    provider_keys: [],
    merchant: {
      business_name: '',
    },
    shopify: {},
    is_eligible_for_installment: false,
  },
};

const paymentReducer = (
  state: PaymentState = initialState,
  action: any
): PaymentState => {
  switch (action.type) {
    case SET_PAYMENT_DETAILS:
      // Store the original amount when first setting payment details or when it's not already stored
      const newState = { ...state, ...action.payload };
      // Only store the original amount if we don't have one yet
      // This ensures we keep the very first amount as the original
      if (!state.originalAmount && action.payload.data?.request_amount) {
        newState.originalAmount = action.payload.data.request_amount;
      } else if (state.originalAmount) {
        // If we already have an original amount, preserve it even when updating other data
        newState.originalAmount = state.originalAmount;
      }
      return newState;
    case RESTORE_ORIGINAL_AMOUNT:
      // Restore the original amount from storage
      if (state.originalAmount) {
        return {
          ...state,
          data: {
            ...state.data,
            request_amount: state.originalAmount,
          },
        };
      }
      return state;
    default:
      return state;
  }
};

export default paymentReducer;
